import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import { getPaymentWidgetById, addPaymentWidgetChargeById, paymentWidgetSplitUp, getHealthCheck, BASE_URLS, getQrPaymentReconnection } from "../../api";
import { PAGES, MESSAGES, SWIREPAY_URL, TabNames, PAYMENT_WIDGET_STATUSES, QR_STATUSES, SESSION_TIME } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import { AmountDivideByHundred } from "../../helper";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achpayment/AchPayment";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import AlertModal from "../../components/modal/alert";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";
import ApplePay from "../../components/applePay/ApplePay";
import Apple from '../../routes/apple';
import getRedirectionUrl from "../../utils/getRedirectionUrl";

type Props = {
    history: {
        push: Function,
    },
}

const WidgetPay = (props: Props) => {

    const { match: { params: { paymentwidgetlinkId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(['CARD']);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${paymentwidgetlinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [processStatus, setProcessStatus] = useState(false);
    const selectedData = localStorage.getItem('widgetInfo');
    const [amountInfo, setAmountInfo] = useState();
    const [interval, setInterval] = useState('');
    const hostName = (window && window.location && window.location.host);
    let widgetsData;
    const [ipAddress, setIpAddress] = useState('');
    const [net, setNet] = useState(null);
    const [serviceFeeEnabled, setServiceFeeEnabled] = useState(false);
    const [feeService, setFeeService] = useState(null);
    const [totalPayable, setTotalPayable] = useState(null);
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [applePayAmount , setApplePayAmount] = useState()
    const [applePayment, setApplePayment] = useState(false);
    const [isApplePay, setIsApplePay] = useState(false);
    const [swirepayUS, setSwirepayUS] = useState(false);
    const [googlePayUs, setGooglePayUs] = useState(false);
    const accountGid = [
      'account-cdfe7eecff324778a88a2727177a1c8f'
    ];

    const getData = async () => {
        const response = await fetch('https://api.ipify.org/?format=json');
        const data = await response.json();
        setIpAddress(data.ip);
    }

    useEffect(() => {
        getData();
    }, []);

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    useEffect(() => {
        if (search) {
            getPaymentWidgetDataWithSearchValue()
        } else {
            getPaymentWidgetData();
        }
    }, [paymentwidgetlinkId, search]);

    useState(() => {
      if (window.ApplePaySession) {
        setIsApplePay(true);
      }
    }, []);

    useEffect(() => {
        setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
        setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
        setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
        if(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'))
            setSupportedPaymentTypes((prev) => [...prev, 'WALLET']);
        if(payment && payment.account && payment.account.supportedPaymentTypes.includes('ACH_LEGACY'))
            setSupportedPaymentTypes((prev) => [...prev, 'ACH_LEGACY']);
    }, [payment]);

    useEffect(() => {
        if (selectedData && payment) {
            widgetsData = JSON.parse(selectedData);
            setInterval(widgetsData.interval);
            setApplePayment(payment && payment.account && payment.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
            setSwirepayUS(payment && payment.account && payment.account.supportedPaymentTypes.includes('SWIREPAY_US'));
            setGooglePayUs(payment && payment.account && payment.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
            setAmountInfo(`${currencyFormatter(AmountDivideByHundred(widgetsData.amount), payment.account.currency.name)}`);
            setApplePayAmount(widgetsData.amount)
            setSubmitBtnText(`${payment.paymentWidget.payButtonLabel} ${currencyFormatter(AmountDivideByHundred(widgetsData.amount), payment.account.currency.name)} ${widgetsData.interval}`)
        }
    }, [selectedData, payment]);

    useEffect(() => {
        setErrorMessage(null);
    }, [selectedTab]);

    const getPaymentWidgetDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getPaymentWidgetById(paymentwidgetlinkId, search);
            if (value) {
                const { status } = value.paymentWidget;
                setPayment(value)
                if (PAYMENT_WIDGET_STATUSES.ACTIVE === status) {
                    setTransactionModalOpen(false);
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        sessionStorage.setItem('fromWidget', true);
                        props.history.push(`${PAGES.PAYMENT_WIDGET}/${paymentwidgetlinkId}`);
                    }, 5000);
                }
            }
        } catch (reason) {
            try {
                const value = await getPaymentWidgetById(paymentwidgetlinkId);
                if (value) {
                    const { status } = value.paymentWidget;
                    if (PAYMENT_WIDGET_STATUSES.ACTIVE !== status) {
                        props.history.push(`${pathname}/expired`);
                        return;
                    }
                    setPayment(value);
                    if (value.account && value.account.portal) {
                        const portal = value.account.portal.test;
                        setIsTest(portal);
                        supportedBankTypes(value.account.supportedPaymentTypes);
                    }
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
            error(reason);
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getSplitUp = async (id, payload, info) => {
        try {
            const value = await paymentWidgetSplitUp(id, payload);
            setNet(value.amount || 0);
            setFeeService(value.serviceFee || 0);
            setTotalPayable(value.totalPayable || 0);
            setAmountInfo(`${currencyFormatter(AmountDivideByHundred(value.totalPayable), info.account.currency.name)}`);
            setSubmitBtnText(`${info.paymentWidget.payButtonLabel} ${currencyFormatter(AmountDivideByHundred(value.totalPayable), info.account.currency.name)} ${widgetsData.interval}`)
        } catch (reason) {
            error(reason);
        }
    }

    const getPaymentWidgetData = async () => {
        setShowSpinner(true);
        try {
            const value = await getPaymentWidgetById(paymentwidgetlinkId, null);
            if (value) {
                const { status } = value.paymentWidget;
                if (PAYMENT_WIDGET_STATUSES.ACTIVE !== status) {
                    props.history.push(`${pathname}/expired`);
                    return;
                }
                // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
                //     const val = await getHealthCheck();
                //     if (val && val.status !== 'ACTIVE') {
                //         setUpiDownTime(true);
                //         notification.open({
                //             message: '',
                //             description: <img src={UPIIMAGE} alt="" />,
                //           });
                //     }
                //   }
                setPayment(value);
                widgetsData = JSON.parse(selectedData);
                if ((value && value.paymentWidget && value.paymentWidget.serviceFeeEnabled) === true) {                    
                    setServiceFeeEnabled(value && value.paymentWidget && value.paymentWidget.serviceFeeEnabled);
                    getSplitUp(paymentwidgetlinkId, widgetsData.amount, value);
                }
                if (value.account && value.account.portal) {
                    const portal = value.account.portal.test;
                    setIsTest(portal);
                    supportedBankTypes(value.account.supportedPaymentTypes);
                }
            }
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.customer && payment.customer.gid;
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod, notify } = data;
        widgetsData = JSON.parse(selectedData);
        await chargeById({ 
            customerDetails: customer, 
            paymentMethodDetails: paymentMethod,
            shouldWhatsAppNotify: notify, 
            customerGid: getCustomerGidFromPayment(payment),
            companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false, 
            amount: widgetsData.amount,
            interval: widgetsData.interval,
        });
    };

    const chargeByCard = async (data) => {
        const { paymentMethod } = data;
        widgetsData = JSON.parse(selectedData);
        const paymentData = {
            companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
            employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
            employeeEmail: widgetsData.email,
            employeeFirstName: widgetsData.firstName,
            employeeLastName: widgetsData.lastName,
            paymentMethodDetails: paymentMethod,
            interval: widgetsData.interval,
            amount: widgetsData.amount,
            customerDetails: {
                email: widgetsData.email,
                name: `${widgetsData.firstName} ${widgetsData.lastName}`,
                phoneNumber: widgetsData?.employDetails,
                taxId: 'NONE',
                taxStatus: 'TAXABLE'
            }
        };
        const userAgent = {
            acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
            ip: ipAddress,
            language: window.navigator.language,
            colorDepth: window.screen.colorDepth,
            screenHeight: window.screen.height,
            screenWidth: window.screen.width,
            timeZone: new Date().getTimezoneOffset(),
            browserUserAgent: window.navigator.userAgent
        };
        paymentData.userAgent = userAgent;
        await chargeById(paymentData);
    };

    const chargeByBank = async (data) => {
        const { fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByNetBanking = async (data) => {
        const { gid, notify } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeBySwirepayUS = async (data) => {
        const { walletAlias, notify } = data;
        widgetsData = JSON.parse(selectedData);
        const paymentMethod = {
            type:"WALLET",
            subType: "SWIREPAY_US",
            swirepayUS: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        const payload = {
            companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
            employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
            employeeEmail: widgetsData.email,
            employeeFirstName: widgetsData.firstName,
            employeeLastName: widgetsData.lastName,
            paymentMethodDetails: paymentMethod, 
            shouldWhatsAppNotify: notify, 
            interval: widgetsData.interval, 
            amount: widgetsData.amount, 
            customerGid: getCustomerGidFromPayment(payment)
        }
        await chargeById(payload);
    };

    const chargeByApple = async (deviceData, amount, customerName, customerEmail,
      customerPhone, countryCode, stateCode, street, postalCode, city,
      cardNetwork, cardType, cardLast4) => {
      const paymentMethod = {
        applePayUS: {
          deviceData: deviceData,
          cardBrand: cardNetwork,
          cardFundingType: cardType,
          applePayDynamicLast4: cardLast4,
          cardLast4: cardLast4
        },
        type: "WALLET",
        subType: "APPLE_PAY_US",
        postalCode: postalCode,
        paymentMethodBillingAddress: {
          city: city,
          countryCode: countryCode,
          state: stateCode,
          street: street
        }
      }
      await chargeById({ paymentMethodDetails: paymentMethod, amount:parseFloat(amount.replace(/,/g, '') * 100),interval:interval, customerGid: getCustomerGidFromPayment(payment) });  
    }

    const chargeByApplePay = async (stripePaymentMethod) => {
      // const meta = stripePaymentMethod;
      const paymentMethod = {
        applePayUS: {
              stripePaymentMethodId: stripePaymentMethod.id,
              cardBrand: stripePaymentMethod.card.brand,
              cardExpMonth: stripePaymentMethod.card.exp_month,
              cardExpYear: stripePaymentMethod.card.exp_year,
              cardFundingType: stripePaymentMethod.card.funding,
              applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
              cardLast4: stripePaymentMethod.card.last4,
              billingAddress: {
                street: stripePaymentMethod.billing_details.address.line1,
                city: stripePaymentMethod.billing_details.address.city,
                state: stripePaymentMethod.billing_details.address.state,
                postalCode: stripePaymentMethod.billing_details.address.postal_code,
                countryCode: stripePaymentMethod.billing_details.address.country
              },
              name: stripePaymentMethod.billing_details.name,
              email: stripePaymentMethod.billing_details.email,
              phone: stripePaymentMethod.billing_details.phone
            },
            customerGid: getCustomerGidFromPayment(payment),
            type: "WALLET",
            subType: "APPLE_PAY_US",
            rawData: {
              stripePaymentMethodId: stripePaymentMethod.id,
              cardBrand: stripePaymentMethod.card.brand,
              cardExpMonth: stripePaymentMethod.card.exp_month,
              cardExpYear: stripePaymentMethod.card.exp_year,
              cardFundingType: stripePaymentMethod.card.funding,
              applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
              cardLast4: stripePaymentMethod.card.last4,
              billingAddress: {
                street: stripePaymentMethod.billing_details.address.line1,
                city: stripePaymentMethod.billing_details.address.city,
                state: stripePaymentMethod.billing_details.address.state,
                postalCode: stripePaymentMethod.billing_details.address.postal_code,
                countryCode: stripePaymentMethod.billing_details.address.country
              },
              name: stripePaymentMethod.name,
              email: stripePaymentMethod.email,
              phone: stripePaymentMethod.phone
            }
          };
      await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
  };

    const chargeById = async (paymentDetails) => {
        setTransactionModalOpen(true);
        try {
            const value = await addPaymentWidgetChargeById(paymentwidgetlinkId, paymentDetails);
            if (value) {
                let paymentUrl;
                let redirectUrl;
                if (interval === 'ONETIME') {
                    paymentUrl = value.paymentSession;
                } else if (interval !== 'ONETIME') {
                    paymentUrl = value.subscription;
                }
                if (paymentUrl) {
                    const { nextActionUrl } = paymentUrl;
                    redirectUrl = paymentUrl.returnUrl;
                    if (nextActionUrl) {
                        window.location = nextActionUrl;
                        return;
                    }
                }
                setTransactionModalOpen(false);
                if(!value?.paymentSession || (value?.paymentSession?.status === 'SUCCEEDED') || (value?.paymentSession?.status === 'PROCESSING') || (value?.paymentSession?.status === 'REQUIRE_ACTION')){
                    setTransactionSuccessModalOpen(true);
                    setTimeout(function () {
                        if (redirectUrl) {
                            window.location = redirectUrl;
                        } else if (!redirectUrl) {
                            sessionStorage.setItem('fromWidget', true);
                            props.history.push(`${PAGES.PAYMENT_WIDGET}/${paymentwidgetlinkId}`);
                        }
                    }, 5000);
                    if (paymentwidgetlinkId) { localStorage.removeItem(`${paymentwidgetlinkId}-tap-index`) }
                } else {
                    setErrorMessage('An error occured');
                };
            }
        } catch (reason) {
            error(reason);
        }
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
        try {
          const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
          if (value) {
            const { status, receiptNumber } = value;
            const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
            if (status === QR_STATUSES.SUCCEEDED) {
              if (!redirectionUri) {
                setTransactionSuccessModalOpen(true);
              }
              setTimeout(function () {
                const uri = getRedirectionUrl(hostName);
                const redirectUrl = redirectionUri ? redirectionUri : '';
                const urlPath = redirectUrl.includes("?");
                if (urlPath) {
                  window.location = `${redirectUrl}&sp-payment-button=${paymentwidgetlinkId}`;
                } else if (!urlPath && redirectUrl) {
                  window.location = `${redirectUrl}?sp-payment-button=${paymentwidgetlinkId}`;
                } else if (uri && !redirectUrl) {
                  window.location = `${uri}receipts/${receiptNumber}`;
                }
              }, timeOut);
              if (paymentwidgetlinkId) { localStorage.removeItem(`${paymentwidgetlinkId}-tap-index`) }
            }
          }
        } catch (reason) {
          error(reason);
        }
      };
    

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            subType: "GOOGLE_PAY_US",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    if(uniquePaymentTypes.includes('WALLET')) {
        if (swirepayUS && interval === 'ONETIME') {
            uniquePaymentTypes.push('SWIREPAY_US');
        }
        const index = uniquePaymentTypes.indexOf('WALLET');
        if (index > -1) {
            uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
        }
    }
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={false}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
            />
        } else if (name === TabNames.CARD) {
            children = <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                hideCustomer={true}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={false}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                chargeByApplePay={chargeByApplePay}
                ApplePayment={applePayment}
            />
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                showMobileViewUpi={true}
                hideQr={false}
                showWhatsAppNotify={false}
                getPaymentById={null}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                upiUrl={null}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                showWhatsAppNotify={false}
                paymentwidgetlinkId={paymentwidgetlinkId}
                iavUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                requiredPhone={false}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
            />
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment}
                showWhatsAppNotify={false}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.APPLE_PAY_US) {
          children = <ApplePay
              headerText={"PAY WITH APPLE PAY"}
              payment={{amount: totalPayable && totalPayable, currency: payment.currency}}
              chargeByApplePay={chargeByApplePay}
              gpayError={null}
              errorMsg={errorMessage}
              errorHeader={null}
          />
      } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else if (name === TabNames.WALLET) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={null}
                showWhatsAppNotify={false}
                upiUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.SWIREPAY_US) {
            widgetsData = JSON.parse(selectedData);
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeBySwirepayUS}
                getPaymentById={getQrPaymentById}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                showWhatsAppNotify={false}
                upiUrl={`${BASE_URLS.PAYMENT_WIDGET}/${paymentwidgetlinkId}`}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                swirepayUS={swirepayUS}
                paymentInterval={interval}
                paymentMethodDetails={true}
                amount={widgetsData?.amount}
                paymentWidget={true}
                employeeDetails={{
                    companyDonation: widgetsData.companyDonation ? widgetsData.companyDonation : false,
                    employmentStatus: widgetsData.employmentStatus ? widgetsData.employmentStatus : false,
                    employeeEmail: widgetsData.email,
                    employeeFirstName: widgetsData.firstName,
                    employeeLastName: widgetsData.lastName
                }}
            />
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children });
        return panel;
    }, []) : [
        {
            children: <CardPayment
                errorMsg={errorMessage}
                errorHeader={null}
                hideCustomer={true}
                customerReadOnly={false}
                submit={chargeByCard}
                preFillCustomer={payment}
                headerText={"Pay With Card"}
                buttonText={submitBtnText}
                netAmount={net}
                serviceFeeAmount={feeService}
                totalPayableAmount={totalPayable}
                serviceFeeEnabled={serviceFeeEnabled}
                isZipCodeRequired={(payment && payment.account && payment.account.collectCustomerAddress)}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
                customerValidation={false}
                prefix={payment && payment.account && payment.account.currency && payment.account.currency.prefix}
                alpha2={payment && payment.account.currency && payment.account.currency.countryAlpha2}
                chargeByApplePay={chargeByApplePay}
                ApplePayment={applePayment}
            />
        }
    ];
// Ensure that `interval` and `isApplePay` are defined in the current scope
console.log(interval , "inteval")
    
const tabPanelsApple = {
    children: applePayment && isApplePay && interval && interval === "ONETIME"
      ? <Apple amount={applePayAmount} chargeByApple={chargeByApple} payment={payment} /> 
      : null
  };

  tabPanels.push(tabPanelsApple);



    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;
    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                            )
                        }
                        <H1Text>
                            Payment Checkout
                        </H1Text>
                        <H2Text>
                            Amount Payable
                        </H2Text>
                        <DescriptionText fontSize="24px">
                            {amountInfo || null}
                        </DescriptionText>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone}
                            partnerImageUrl={partnerImageUrl}
                            bankImageUrl={bankImageUrl}
                            whiteLabel={payment && payment.account && payment.account.whiteLabel}
                        />
                        {agregatorName === 'EPAYMENTS' ?
                            <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                <a href="https://www.swirepay.com" target="_blank" >
                                    <img src={EPaymentImg} alt="" />
                                </a>
                            </div>
                            :
                            agregatorName === 'OMEGAITR' ?
                                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                    <a href="https://www.swirepay.com" target="_blank" >
                                        <img src={OMEGAITRlogo} alt="" />
                                    </a>
                                </div>
                                :
                                ''
                        }
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={amountInfo} bankImageUrl={bankImageUrl} />
                <PaymentMethodTabs
                    name={paymentwidgetlinkId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={getMenuTabs(uniquePaymentTypes)}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                    applePayment={applePayment}
                    isApplePay ={isApplePay}
                    interval={interval}
                    accountGid={payment?.account?.gid}
                />
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} />
                <AlertModal
                    showIcon={alertConfig.showIcon}
                    isOpen={alertConfig.isOpen}
                    hideBtn={alertConfig.hideBtn}
                    cancel={alertConfig.cancel}
                    header={alertConfig.header}
                    body={alertConfig.body}
                    submitBtnText={alertConfig.submitBtnText}
                    cancelBtnText={alertConfig.cancelBtnText}
                    showCancelBtn={alertConfig.showCancelBtn}
                    showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default WidgetPay;
